import * as React from 'react';
import {RouteChildrenProps} from 'react-router-dom';
import {BaseScreen} from '../../../components/screens/BaseScreen';
import {CenteredWrapper} from '../../../components/screens/layout';
import {SvgImage} from '../../../components/SvgImage/SvgImage';

export class PasswordResetSuccess extends React.Component<
  RouteChildrenProps<{}, {redirect: string}>
> {
  getRedirectUrl = (): string => {
    return (this.props.location.state || {}).redirect || '/dashboard';
  };

  render() {
    return (
      <BaseScreen
        helmetTitle="Password Reset Success"
        headerTitle="Forgot Password"
        title="Password Reset!"
        instructions="Your password has now been reset and you are logged in."
        actionButtons={[
          {
            href: this.getRedirectUrl(),
            children: 'Go To My Dashboard',
          },
        ]}
      >
        <CenteredWrapper>
          <SvgImage name="passwordReset" />
        </CenteredWrapper>
      </BaseScreen>
    );
  }
}
